export enum ViewName {
  MaintenancePage = 'maintenance_page',
  OrganizeStoriesAndFoldersPage = 'organize_stories_and_folders_page',
  OrganizeSectionsAndStoriesPage = 'organize_sections_and_stories_page',
  StoriesSettingsPage = 'stories_settings_page',
  StoryPreviewPage = 'story_preview_page',
  StoryViewPage = 'story_view_page',
  PublicationViewPage = 'publication_view_page',
  StoriesAndPublicationAndTemplateListPage = 'stories_and_publication_and_template_list_page',
  SetupOnlinePublicationPage = 'setup_online_publication_page',
  PublicationCustomCssViewPage = 'publication_custom_css_view_page',
  PublicationSetupPdfViewPage = 'publication_setup_pdf_view_page',
  StorySetupPdfViewPage = 'story_setup_pdf_view_page'
}
